import React, {createContext, useContext} from 'react';
import {AppEditorStore} from './appEditorStore';
import {PluginStore} from './pluginStore';
import {UserStore} from "./UserStore";
import {LocalSettingsStore} from "./localSettings";
import {FolderStore} from "./FolderStore";
import {PageStore} from "./PageStore";
import {NotificationStore} from "./NotificationStore";
import {ModalStore} from "./ModalStore";
import {ConfirmStore} from "./ConfirmStore";
import {SocketStore} from "./SocketStore";
import UndoManager from "./UndoManager";


let store;


const StoreContext = createContext(undefined);

export class Store {
    appEditorStore;
    localSettingsStore;
    modalStore;
    pluginStore;
    userStore;
    folderStore;
    pageStore;
    notificationStore;
    confirmStore;
    undoManager;
    socketStore;


    // pointerBadgeStore;

    constructor(initialState) {
        this.appEditorStore = new AppEditorStore(this, initialState?.appEditorStore);
        this.localSettingsStore = new LocalSettingsStore(this, initialState?.localSettingsStore);
        this.pluginStore = new PluginStore(this);
        this.appEditorStore.init();
        this.userStore = new UserStore(this);
        this.notificationStore = new NotificationStore(this);
        this.folderStore = new FolderStore(this);
        this.pageStore = new PageStore(this);
        this.modalStore = new ModalStore(this);
        this.confirmStore = new ConfirmStore(this);
        this.socketStore = new SocketStore(this);
        this.undoManager = new UndoManager(this);

    }
}

export const StoreProvider = ({children, initialState}) => {
    if (!store) {
        store = new Store(initialState);
    }

    return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export const useStore = () => {
    const context = useContext(StoreContext);
    if (!context) throw new Error('useStore must be used inside of StoreProvider');

    return context;
}

export const getStore = () => {
    if (!store) throw new Error('Store has not been initialized');

    return store;
};

// @ts-ignore
window.getStore = getStore;
